import { Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class GetAddressService {
  constructor(private sanitizer: DomSanitizer) {}

  private normalizeStreet(street: string): string {
    if (!street) {
      return '';
    }

    return street.split('|')[0].split('#')[0].trim();
  }

  private buildAddressQuery(address: any, zipValue: string): string {
    const street = this.normalizeStreet(address?.streetName || address?.line1 || '');
    const city = address?.city || '';
    const state = address?.stateCode || address?.state || '';
    const zip = zipValue || '';

    return [street, city, state, zip].filter((value) => !!value).join(',');
  }

  getAddress(object: any, type: any): SafeUrl {
    let address, aArray;

    const google = `https://www.google.com/maps/embed/v1/place?q=`,
      googleQuery = `&zoom=17&key=AIzaSyCYInitcfnCtO4y2J7YE2maV3gZ5-66P2c`;

    if (type === 'claims') {
      aArray = object.address;
      address = encodeURIComponent(this.buildAddressQuery(aArray, aArray?.zipCode?.digits));
    } else {
      if (object.policyType === 'BUSINESS_OWNERS_POLICY') {
        aArray = object.property[0].address;
      } else {
        aArray = object.residentialAddress;
      }
      address = encodeURIComponent(this.buildAddressQuery(aArray, aArray?.zipCode?.code || aArray?.zipCode?.digits));
    }

    const url = `${google}${address}${googleQuery}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
